const windowSizes = {
  lg: 1024,
  md: 600,
  sm: 0
}

export default windowSizes
